// Helper para tesorería: previene doble-submit y añade header X-Idempotency-Key.
// Motivo (incidente COB-000035 · 15/09/2026): un doble-click generó 9 cobranzas.
//
// Uso:
//   const submit = useTreasurySubmit();
//   const onClick = () => submit(async (key) => {
//     await axios.post(url, payload, { withCredentials: true, headers: { 'X-Idempotency-Key': key } });
//   });
//
// El helper garantiza que un 2° click durante un submit en curso es ignorado.

import { useRef, useState, useCallback } from 'react';

const _uuid = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  // Fallback muy simple si el navegador no soporta crypto.randomUUID
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export function useTreasurySubmit() {
  const inFlight = useRef(false);
  const [submitting, setSubmitting] = useState(false);

  const run = useCallback(async (fn) => {
    if (inFlight.current) return; // 2° click ignorado
    inFlight.current = true;
    setSubmitting(true);
    const key = _uuid();
    try {
      return await fn(key);
    } finally {
      inFlight.current = false;
      setSubmitting(false);
    }
  }, []);

  return { run, submitting };
}

// Header estándar para incluir en POSTs de tesorería.
export const idempotencyHeader = (key) => ({ 'X-Idempotency-Key': key });
